module.exports = __webpack_public_path__ + "static/media/转接模块A1.55df21e9.png";